module.exports = __webpack_public_path__ + "static/img/1-1Z5291KT0H8.be43540.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z5291KT0H8.jpg
// module id = o6/G
// module chunks = 0